import { atom, selector } from "recoil";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";

export type authType = {
  user_token_id: number;
  device_id: string;
  device_name: null | undefined | string;
  is_main: number;
  refresh_token: string;
  user_id: number;
  phone_number: string;
  email: string;
  store_list: authStoreType[];
};

export type authStoreType = {
  store_id: number;
  store_type: number;
  id_order: number;
  store_code: string;
  phone_number: string;
  store_name: string;
  auto_confirmed: number;
  address1: string | null;
  address2: string | null;
  city: null;
  province: null;
  postcode: null;
  lat: string | null;
  lng: string | null;
  parking_image: null | string;
  parking_pan: null | string;
  parking_tilt: null | string;
  parking_zoom: null | number;
  pickup_address: null;
  is_mega_store: number;
  is_hidden_on_map: number;
  description: string | null;
  description_extra: string | null;
  description_noti: string | null;
  description_holiday: string | null;
  order_time: number;
  review_count: number;
  pause: number;
  noti_nearby_distance: null | number;
  noti_arrival_distance: null | number;
  parking_time: null | number;
  pickup_type: number;
  status: number;
  is_test_shop: number;
};

export type CurrentStoreType = {
  name: string;
  value: authStoreType | null;
};

/*
export const authState_off = atom<authType>({
  key: "masterAuth",
  default: {
    // app_type: 8,
    refresh_token:
      "IrPHokHxNGQOPxee2Ow0NCvAgncX26OWpK1p4VVzxksEtT09KJ66wTcdieBw1hiPtqNwfYMU6vaxJtu7NrFgcpY8SJMhP07uQr3nuVqD4tILhSJnmt4jjt2M6kPvxGZM",
    user_token_id: 3781,
    device_id: "000EC5",
    device_name: null,
    is_main: 1,
    user_id: 1301,
    phone_number: "01073128521",
    email: "kkmj",
    store_list: [
      {
        store_id: 210,
        store_type: 2,
        id_order: 1,
        store_code: "s3xiAQ0Leb6",
        phone_number: "01073128521",
        store_name: "스루카페",
        address1: "서울 동작구 국사봉길 2 (신대방동)",
        address2: "1층",
        city: null,
        province: null,
        postcode: null,
        lat: "37.4989248453",
        lng: "126.9284514891",
        parking_image:
          "https://prd-throo-store-product.s3.ap-northeast-2.amazonaws.com/store-id-0000000/photo_1666251723511-1024.jpg",
        parking_pan: "162.9035845621",
        parking_tilt: "15.1244632026",
        parking_zoom: -1,
        pickup_address: null,
        is_mega_store: 0,
        is_hidden_on_map: 0,
        description:
          "바보육회는 법학 강사 17년 경력 '바보선생'이 운영하는 평균별점 5점, 배민 맛집랭킹(육회부문) 1등의 한우 육회, 육사시미 그리고 육전 전문점입니다.",
        description_extra:
          "육회: 국내산 한우 / 육사시미: 국내산 한우 / 육전: 미국산 or 호주산 / 곰탕: 국내산 한우 / 배추: 국내산 / 상추: 국내산 / 당근: 중국산 / 순살 가라아게: 미국산 / 옥수수: 중국산 / 감자: 벨기에산",
        description_noti: "영업시간 / 11:00~02:00(익일)\r\n매월 1일 휴무일",
        description_holiday: "매일 : 00:00~18:00",
        order_time: 0,
        review_count: 11,
        pause: 0,
        noti_nearby_distance: 150,
        noti_arrival_distance: 50,
        parking_time: 10,
        pickup_type: 1,
        status: 1,
        is_test_shop: 0,
      },
      {
        store_id: 1342,
        store_type: 1,
        id_order: 0,
        store_code: "sPHSHDUG3yu",
        phone_number: "01073128521",
        store_name: "블루빈 카페",
        address1: "서울 강남구 선릉로 551 (역삼동, 새롬빌딩)",
        address2: "1층 스루",
        city: null,
        province: null,
        postcode: null,
        lat: "37.5078630391",
        lng: "127.0452170666",
        parking_image: "https://api.ivid.kr/img/store/00006/austin_parking.jpg",
        parking_pan: "0.0000000000",
        parking_tilt: "0.0000000000",
        parking_zoom: 0,
        pickup_address: null,
        is_mega_store: 0,
        is_hidden_on_map: 0,
        description: "맛있는 아이스크림매장입니다.1",
        description_extra: "이탈리아~",
        description_noti:
          "[ 2021년 대한민국소비자브랜드 대상 ]\r\n\r\n100% 자연모짜렐라치즈 + 48시간 이상 저온숙성흑미도우 + 프레드만의 특제소스와 더불어 신선한 야채를 통해 고객님들께 맛있는 피자를 대접하겠습니다.\r\n\r\n*누락 또는 불편사항은 언제든지 매장으로 연락주세요.",
        description_holiday: "매일 : 08:00~17:50",
        order_time: 0,
        review_count: 42,
        pause: 1,
        noti_nearby_distance: 100,
        noti_arrival_distance: 50,
        parking_time: 5,
        pickup_type: 1,
        status: 1,
        is_test_shop: 0,
      },
      {
        store_id: 1343,
        store_type: 1,
        id_order: 0,
        store_code: "sNi9UptmbQD",
        phone_number: "01073128521",
        store_name: "빈매장12",
        address1: "경기 성남시 분당구 대왕판교로 477 (판교동, 낙생고등학교)",
        address2: "빈자리",
        city: null,
        province: null,
        postcode: null,
        lat: "37.5657000000",
        lng: "126.9769000000",
        parking_image: null,
        parking_pan: null,
        parking_tilt: null,
        parking_zoom: null,
        pickup_address: null,
        is_mega_store: 0,
        is_hidden_on_map: 0,
        description: null,
        description_extra: "원산지이벤트",
        description_noti:
          "[ 2021년 대한민국소비자브랜드 대상 ]\n\n100% 자연모짜렐라치즈 + 48시간 이상 저온숙성흑미도우 + 프레드만의 특제소스와 더불어 신선한 야채를 통해 고객님들께 맛있는 피자를 대접하겠습니다.\n\n*누락 또는 불편사항은 언제든지 매장으로 연락주세요.",
        description_holiday: null,
        order_time: 0,
        review_count: 6,
        pause: 1,
        noti_nearby_distance: 100,
        noti_arrival_distance: 50,
        parking_time: 5,
        pickup_type: 0,
        status: 0,
        is_test_shop: 0,
      },
      {
        store_id: 1344,
        store_type: 1,
        id_order: 0,
        store_code: "sG70qNewTR5",
        phone_number: "01073128521",
        store_name: "테스트",
        address1: "서울 성북구 아리랑로 3 (동소문동6가, 기업은행)",
        address2: "기업은행",
        city: null,
        province: null,
        postcode: null,
        lat: null,
        lng: null,
        parking_image: null,
        parking_pan: "0.0000000000",
        parking_tilt: "0.0000000000",
        parking_zoom: 0,
        pickup_address: null,
        is_mega_store: 0,
        is_hidden_on_map: 0,
        description: "테스트",
        description_extra: "원산지",
        description_noti: "공지사항",
        description_holiday: "토요일 : 00:00~01:00\r\n토요일 : 04:00~05:00",
        order_time: 0,
        review_count: 6,
        pause: 0,
        noti_nearby_distance: 100,
        noti_arrival_distance: 50,
        parking_time: 5,
        pickup_type: 1,
        status: 1,
        is_test_shop: 0,
      },
      {
        store_id: 1345,
        store_type: 1,
        id_order: 0,
        store_code: "sHTiB5AZdn6",
        phone_number: "01073128521",
        store_name: "서서울",
        address1: "서울 양천구 남부순환로58길 33 (신월동)",
        address2: "1층 105호 카페서서울",
        city: null,
        province: null,
        postcode: null,
        lat: "37.5291752709",
        lng: "126.8313072644",
        parking_image: null,
        parking_pan: "0.0000000000",
        parking_tilt: "0.0000000000",
        parking_zoom: 0,
        pickup_address: null,
        is_mega_store: 0,
        is_hidden_on_map: 0,
        description: "서서울호수공워누앞 뷰와 디저트 그리고 커피맛집",
        description_extra: "사랑합니다",
        description_noti: "맛난커피 드시고 가세요~",
        description_holiday: "매일 : 10:00~20:30",
        order_time: 0,
        review_count: 6,
        pause: 1,
        noti_nearby_distance: 50,
        noti_arrival_distance: 50,
        parking_time: 5,
        pickup_type: 1,
        status: 1,
        is_test_shop: 0,
      },
      {
        store_id: 1346,
        store_type: 1,
        id_order: 0,
        store_code: "sGgLvKnUP8m",
        phone_number: "01073128521",
        store_name: "서동진의 커피랩 영통점",
        address1: "경기 수원시 영통구 반달로 96-1 (영통동)",
        address2: "1층 서동진의 커피랩 영통점",
        city: null,
        province: null,
        postcode: null,
        lat: "37.2523527323",
        lng: "127.0780624572",
        parking_image: null,
        parking_pan: null,
        parking_tilt: null,
        parking_zoom: null,
        pickup_address: null,
        is_mega_store: 0,
        is_hidden_on_map: 0,
        description:
          "스페셜티 커피 전문 카페로 고객분들께 맛있는 커피를 제공하고 있습니다.",
        description_extra: "",
        description_noti: "",
        description_holiday:
          "월요일 : 12:00~22:00\r\n화요일 : 12:00~22:00\r\n수요일 : 12:00~22:00\r\n목요일 : 12:00~22:00\r\n금요일 : 12:00~22:00\r\n토요일 : 13:00~18:00\r\n일요일 : 13:00~18:00",
        order_time: 0,
        review_count: 6,
        pause: 0,
        noti_nearby_distance: 100,
        noti_arrival_distance: 50,
        parking_time: 5,
        pickup_type: 1,
        status: 1,
        is_test_shop: 0,
      },
      {
        store_id: 1347,
        store_type: 1,
        id_order: 0,
        store_code: "sIIUHqfBiic",
        phone_number: "01073128521",
        store_name: "흑석커피",
        address1: "서울 동작구 서달로14가길 5 (흑석동, 삼원빌딩)",
        address2: "1층 흑석커피",
        city: null,
        province: null,
        postcode: null,
        lat: "37.5076660622",
        lng: "126.9630204372",
        parking_image:
          "https://prd-throo-store-product.s3.ap-northeast-2.amazonaws.com/store-id-0001347/photo_1665641915878-1024.jpg",
        parking_pan: "144.9754516998",
        parking_tilt: "23.3414394710",
        parking_zoom: 0,
        pickup_address: null,
        is_mega_store: 0,
        is_hidden_on_map: 0,
        description:
          "커피, 생과일주스, 마들렌을 판매하고 있는 흑석커피 입니다.\r\n커피는 고소한 원두를 사용합니다.\r\n주스는 생과일을 갈아서 제공해 드립니다.",
        description_extra: "1234",
        description_noti: "매주 일요일은 휴무",
        description_holiday:
          "월요일 : 10:00~20:30\r\n화요일 : 10:00~20:30\r\n수요일 : 10:00~20:30\r\n목요일 : 10:00~20:30\r\n금요일 : 10:00~20:30\r\n토요일 : 10:00~20:30",
        order_time: 0,
        review_count: 6,
        pause: 1,
        noti_nearby_distance: 100,
        noti_arrival_distance: 50,
        parking_time: 5,
        pickup_type: 1,
        status: 0,
        is_test_shop: 0,
      },
      {
        store_id: 1348,
        store_type: 1,
        id_order: 0,
        store_code: "s6VT7CMrvf1",
        phone_number: "01073128521",
        store_name: "크로플샵",
        address1: "경기 평택시 고덕면 서동대로 2651 (궁리, 태평아파트)",
        address2: "상가동 109호",
        city: null,
        province: null,
        postcode: null,
        lat: "37.0166519293",
        lng: "127.0342932075",
        parking_image: null,
        parking_pan: "29.8125029937",
        parking_tilt: "14.2304020246",
        parking_zoom: 0,
        pickup_address: null,
        is_mega_store: 0,
        is_hidden_on_map: 0,
        description:
          "크로플&캔커피는 크로플샵!\r\n크로플과 캔커피 포장.배달 전문점입니다.\r\n그날 그날 직접 구운 다양한 크로플과\r\n신선한 캔 포장 음료가 준비되어 있습니다.\r\n\r\n달달한 게 땡길 때 찾아 주세요 :)",
        description_extra: "",
        description_noti:
          "안녕하세요. 크로플샵입니다. \r\n저희 크로플샵을 찾아 주신 단골 손님들께\r\n감사의 의미로 리뷰이벤트를 진행합니다. \r\n5번째 주문 시 원하시는 메뉴 1개(뭐든����️)를\r\n서비스로 제공해 드립니다. \r\n\r\n〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️\r\n\r\n����하이파이브(Hi! Five) 리뷰이벤트 참여 방법����\r\n1️⃣주문 후 리뷰란에 주문 횟수 남기기\r\n 예] 1번 주문했어요\r\n        첫번째 주문\r\n\r\n2️⃣ 2~4번까지 반복 (리뷰 남기기)\r\n예] 2번 주문했어요\r\n       2번째 주문\r\n\r\n3️⃣5번째 주문 시 가게 요청 사항에\r\n    아이디와 원하는 메뉴1개 남기기\r\n예] 크로플존맛/ 과일폭탄 크로플\r\n\r\n✅️반복 참여 가능����\r\n✅️포장 주문 참여 불가능����(➡️쿠폰 대체)\r\n\r\n〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️〰️\r\n\r\n맛있게 드시고 ����\r\n별⭐️⭐️⭐️⭐️⭐️리뷰와 찜❤️ 부탁드려요����\r\n",
        description_holiday: null,
        order_time: 0,
        review_count: 6,
        pause: 1,
        noti_nearby_distance: 100,
        noti_arrival_distance: 50,
        parking_time: 5,
        pickup_type: 0,
        status: 0,
        is_test_shop: 0,
      },
    ],
  },
  effects: [
    ({ setSelf, onSet }) => {
      const savedAuthData = AsyncLocalStorage.getItem("auth");

      if (savedAuthData) setSelf(savedAuthData);

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem("auth")
          : AsyncLocalStorage.setItem("auth", JSON.stringify(newValue));
      });
    },
  ],
});
*/

export const authState = atom<authType>({
  key: "masterAuth",
  default: {
    refresh_token: "",
    user_token_id: 3781,
    device_id: "000EC5",
    device_name: null,
    is_main: 1,
    user_id: 1301,
    phone_number: "01073128521",
    email: "kkmj",
    store_list: [],
  },
  effects: [
    ({ setSelf, onSet }) => {
      const savedAuthData = AsyncLocalStorage.getItem("auth");

      if (savedAuthData) setSelf(savedAuthData);

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem("auth")
          : AsyncLocalStorage.setItem("auth", JSON.stringify(newValue));
      });
    },
  ],
});

export const authStoreListState = selector<authStoreType[]>({
  key: "authStoreList",
  get: ({ get }) => {
    let auth: any = get(authState);

    return auth.store_list.filter((item: authStoreType) => {
      return item.store_type === 1;
    });
  },
});

export const currentStoreState = atom<CurrentStoreType>({
  key: "currentStore",
  default: {
    name: "",
    value: null,
  },
});

export const versionState = atom<string>({
  key: "version",
  default: "",
  effects: [
    ({ setSelf, onSet }) => {
      const savedData = AsyncLocalStorage.getItem("version");

      if (savedData) setSelf(savedData);

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem("version")
          : AsyncLocalStorage.setItem("version", newValue);
      });
    },
  ],
});
